import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { ApiService } from '../../../services/api/api.service';

const name = 'DASHBOARD_SETTINGS';

export const patchEmail = createAsyncThunk(`${name}/PATCH_EMAIL`,
  async ({payload}, thunkApi) => {
    try {
      const response = await ApiService.patch('/user/email', {...payload});
      let data = await response.data;
      if (response.status === 200) {
        return data;
      }
      return thunkApi.rejectWithValue(data);
    } catch (e) {
      return thunkApi.rejectWithValue(e);
    }
  });

export const patchPassword = createAsyncThunk(`${name}/POST_PASSWORD`,
    async ({payload}, thunkApi) => {
      try {
        const response = await ApiService.post('/user/change-password', {currentPassword: payload?.currentpassword, newPassword: payload?.newpassword});
        let data = await response.data;
        if (response.status === 200) {
          return data;
        }
        return thunkApi.rejectWithValue(data);
      } catch (e) {
        return thunkApi.rejectWithValue(e);
      }
    });

const initialState = {
  isFetching: false,
  isSuccess: false,
  isError: false,
  errorMessage: '',
};

export const dashboardSettingsSlice = createSlice({
  name,
  initialState: initialState,
  extraReducers: {
    [patchEmail.fulfilled]: (state, { payload }) => {
      state.isFetching = false;
      state.isSuccess = true;
      return state;
    },
    [patchEmail.rejected]: (state, { payload }) => {
      state.isFetching = false;
      state.isError = true;
      state.errorMessage = payload?.message || '';
    },
    [patchEmail.pending]: (state) => {
      state.isFetching = true;
    },
    [patchPassword.fulfilled]: (state, { payload }) => {
      state.isFetching = false;
      state.isSuccess = true;
      return state;
    },
    [patchPassword.rejected]: (state, { payload }) => {
      state.isFetching = false;
      state.isError = true;
      state.errorMessage = payload?.message || '';
    },
    [patchPassword.pending]: (state) => {
      state.isFetching = true;
    }
  }
});
